export default "__VITE_ASSET__24ed0a3d__"